/**
 * Get navigator information and parse name and version
 * @returns {Object} { name: string, version: string }
 */
export function getNavigatorInfo(): { name: string; version: string } {
  const ua = navigator.userAgent;
  let name = 'Unknown';
  let version = 'Unknown';

  // List of common browsers and their user agent patterns
  const browsers = [
    { name: 'Edge', pattern: /Edg\/([\d.]+)/ },
    { name: 'Chrome', pattern: /Chrome\/([\d.]+)/ },
    { name: 'Firefox', pattern: /Firefox\/([\d.]+)/ },
    { name: 'Safari', pattern: /Version\/([\d.]+).*Safari/ },
    { name: 'Opera', pattern: /OPR\/([\d.]+)/ },
    { name: 'Internet Explorer', pattern: /MSIE\s([\d.]+)/ },
    { name: 'Internet Explorer', pattern: /Trident\/.*rv:([\d.]+)/ }
  ];

  for (let nav of browsers) {
    const match = ua.match(nav.pattern);
    if (match) {
      name = nav.name;
      version = match[1];
      break;
    }
  }

  return { name, version };
}

/**
 * Determine if the current device is a mobile device
 * Optionally, specify a type of mobile device to check for
 * @param {string} [typeOfMobile] - Optional specific mobile device type to check
 * @returns {boolean} true if mobile device, false otherwise
 */
export function isMobileDevice(typeOfMobile?: string): boolean {
  if (typeof navigator === 'undefined' || !navigator.userAgent) {
    return false;
  }

  const ua = navigator.userAgent.toLowerCase();

  let mobilePattern = typeOfMobile
    ? [new RegExp(typeOfMobile, 'i')]
    : [/android/i, /iphone/i, /ipad/i, /ipod/i, /blackberry/i, /windows phone/i, /opera mini/i, /mobile/i];

  return mobilePattern.some((pattern) => pattern.test(ua));
}
